import {
    HIGHLIGHT_IN_MAP,
    CLEAR_MAP_HIGHLIGHT,
    NAVIGATE_CAROUSEL,
    CLEAR_CAROUSEL_FOCUS
} from '../actions/action-types';

export default function reduceGreatPlaces(state = {}, action) {
    switch (action.type) {
        case HIGHLIGHT_IN_MAP:
            return {
                ...state,
                highlightedId: action.listingId
            };

        case CLEAR_MAP_HIGHLIGHT:
            return {
                ...state,
                highlightedId: null
            };

        case NAVIGATE_CAROUSEL:
            return {
                ...state,
                carouselFocus: action.listingId
            };

        case CLEAR_CAROUSEL_FOCUS:
            return {
                ...state,
                carouselFocus: null
            };

        default:
            return state;
    }
}
